import storage from '~/util/storage'

export default ({ app }, inject) => {
  inject('storage', storage)
}
